/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-unused-vars */
import { Card, LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import { Button, ButtonToolbar, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import AppConfig from "../../../config/AppConfig";

class BelumMengisi extends Component {
  constructor(props, context) {
    super(props, context);
  }
  state = {
    loadingList: true,
    daftarPT: [],
    lembaga: "",
    tipe: "",
  };

  componentDidMount() {
    var queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var tipe = urlParams.get("tipe");
    var lembaga = urlParams.get("lembaga");
    var tahun_siklus = urlParams.get("tahun_siklus") || new Date().getFullYear();
    console.log(tipe);
    console.log(lembaga);
    this.setState({
      tipe: tipe,
      lembaga: lembaga,
    });

    this.setState({ loadingList: true, tipe: tipe });
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    // console.log(userdata);

    axios
      .get(AppConfig.ListDetailSPMI + tipe + "?id_bp=" + userdata.i_idbp + "&lembaga=" + lembaga + "&tahun_siklus=" + tahun_siklus)
      .then((res) => {
        this.setState({
          loadingList: false,
          daftarPT: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // exportExcel = () => {
  //   let list_data = this.state.daftarPT;
  //   var title =
  //     "<h3>Rekap Pelaporan SPMI Berdasarkan Perguruan Tinggi Yang Belum Mengisi</h3>";
  //   var tab_text =
  //     title +
  //     "<table border='2'><thead><tr><th>No</th><th>Perguruan Tinggi</th><th>Status</th></tr></thead><tbody>";
  //   var row = "";
  //   list_data.map((list, i) => {
  //     var no = i + 1;
  //     row += "<tr>";
  //     row += "<td align='center'>" + no + "</td>";
  //     row += "<td align='left'>" + list.nm_lemb + "</td>";
  //     row += "<td align='center'> - </td>";
  //     row += "</tr>";
  //   });

  //   tab_text = tab_text + row + "</tbody></table>";

  //   tab_text = tab_text.replace(/<A[^>]*>|<\/A>/g, "");
  //   tab_text = tab_text.replace(/<img[^>]*>/gi, "");
  //   tab_text = tab_text.replace(/<input[^>]*>|<\/input>/gi, "");

  //   var link = window.document.createElement("a");

  //   link.setAttribute(
  //     "href",
  //     "data:text/xls;charset=utf-8,%EF%BB%BF" + encodeURIComponent(tab_text)
  //   );
  //   link.setAttribute("download", "rekap_pelaporan_spmi_pt_belum_mengisi.xls");
  //   link.click();
  //   return false;
  // };

  render() {
    // let userdata = JSON.parse(localStorage.getItem("sessiondata"));


    var queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let tahun_sik = urlParams.get("tahun_siklus");
    let i = 0;
    let list_result = [];
    if (this.state.daftarPT !== undefined) {
      for (var key in this.state.daftarPT) {
        list_result[i] = {
          result: this.state.daftarPT[key],
        };
        i++;
      }
    }

    let subtitle = "";
    if (this.state.tipe === "belumisi") {
      subtitle = "Belum Mengisi";
    }
    if (this.state.tipe === "pengaturanlengkap") {
      subtitle = "Pengaturan Terisi Lengkap";
    }
    if (this.state.tipe === "pengaturanbelumlengkap") {
      subtitle = "Pengaturan Terisi Belum Lengkap";
    }
    if (this.state.tipe === "pengaturanlengkapterverifikasi") {
      subtitle = "Pengaturan Terverifikasi";
    }
    if (this.state.tipe === "evaluasilengkap") {
      subtitle = "Evaluasi Terisi Lengkap";
    }
    if (this.state.tipe === "evaluasilengkapterverifikasi") {
      subtitle = "Evaluasi Terverifikasi";
    }
    if (this.state.tipe === "pengendalianterisi") {
      subtitle = "Pengendalian Terisi";
    }
    if (this.state.tipe === "pengendalianterverifikasi") {
      subtitle = "Pengendalian Terverifikasi";
    }
    if (this.state.tipe === "peningkatanterisi") {
      subtitle = "Peningkatan Terisi";
    }
    if (this.state.tipe === "peningkatanterverifikasi") {
      subtitle = "Peningkatan Terverifikasi";
    }

    return (
      <>
        <Card style={{ padding: "2%" }}>
          <div className="row" style={{ marginBottom: "12px" }}>
            <div className="col-md-4 text-left"></div>
            <div className="col-md-4 text-center">
              <strong style={{ fontSize: "18px" }}>
                Daftar Perguruan Tinggi ({this.state.lembaga}) <br />
                {subtitle} pada tahun {tahun_sik}
              </strong>
            </div>
            <div className="col-md-4">
              <div style={{ float: "right" }}>
                {this.state.loadingList === false ? (
                  <>
                    <ButtonToolbar>
                      <span className="svg-icon svg-icon-2x svg-icon-white">
                        <Link to="/rekapitulasi">
                          <Button variant="secondary">Kembali</Button>
                        </Link>
                      </span>
                    </ButtonToolbar>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <Table responsive hover style={{ overflow: "auto" }}>
            <thead
              className="text-white"
              style={{ backgroundColor: "#3047ad" }}
            >
              <tr>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                >
                  No
                </th>
                <th
                  style={{
                    verticalAlign: "middle",
                    textAlign: "left",
                  }}
                >
                  Perguruan Tinggi
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.loadingList === true ? (
                <tr>
                  <td colSpan="10">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              ) : list_result.length > 0 ? (
                list_result.map((list, i) => (
                  <tr>
                    <td
                      style={{ verticalAlign: "middle", textAlign: "center" }}
                    >
                      {i + 1}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.nm_lemb}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>
      </>
    );
  }
}
export default BelumMengisi;
